import { TUtpItem } from 'shared/types/utp';
import * as style from './styles.css';
import { clsx } from 'clsx';
import { Title } from '../Title';
import { useDeviceType } from '@cian/ui-kit';

interface IUtpProps {
  ItemForRender: React.FC<TUtpItem>;
  items: TUtpItem[];
  title: string;
  withoutMargin?: boolean;
  isRowDirection?: boolean;
}

export const Utp: React.FC<IUtpProps> = ({ ItemForRender, items, title, withoutMargin, isRowDirection }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(style['container'], style[device], withoutMargin && style['without-margin'])}>
      <Title>{title}</Title>
      <div className={clsx(style['list'], isRowDirection && style['row-direction'])}>
        {items.map(item => (
          <ItemForRender key={item.id} {...item} />
        ))}
      </div>
    </div>
  );
};
